import { useCallback, useState } from "react";

/** The dialogs the user detail page hosts; each has its own independent open flag. */
export type UserDetailDialog =
  "deactivate" | "reactivate" | "changeRole" | "delete" | "notify" | "testAccount";

export type UserDetailDialogsOpen = Readonly<Record<UserDetailDialog, boolean>>;

export const CLOSED_DIALOGS: UserDetailDialogsOpen = {
  deactivate: false,
  reactivate: false,
  changeRole: false,
  delete: false,
  notify: false,
  testAccount: false,
};

/** Open-state of the six user-detail dialogs, one immutable record instead of six booleans. */
export function useUserDetailDialogs() {
  const [open, setOpen] = useState<UserDetailDialogsOpen>(CLOSED_DIALOGS);
  const setDialogOpen = useCallback((dialog: UserDetailDialog, next: boolean) => {
    setOpen((prev) => ({ ...prev, [dialog]: next }));
  }, []);
  const openDialog = useCallback(
    (dialog: UserDetailDialog) => setDialogOpen(dialog, true),
    [setDialogOpen],
  );
  return { open, openDialog, setDialogOpen };
}
